export const TERMS_VERSION = "1.0";

export const TERMS_DOC = [
  {
    title: "1. Objeto del servicio",
    body: "Aprea Gestora (en adelante, «la Gestora») presta un servicio de gestión de incidencias físicas para pequeños comercios. La Gestora actúa como intermediario de gestión entre el comercio y los profesionales técnicos especializados. La Gestora no es una aseguradora ni una empresa de reparaciones.",
  },
  {
    title: "2. Comunicación de incidencias",
    body: "El cliente comunica cada incidencia aportando una descripción del problema y un vídeo de la misma. La Gestora recibe y analiza la incidencia, responde al cliente con la mayor brevedad posible y la comunica al técnico especializado correspondiente.",
  },
  {
    title: "3. Compromiso de 24 horas hábiles",
    body: "Desde la gestión de la incidencia comienza la cuenta atrás: compromiso de disponer de un técnico especializado en el comercio en un plazo máximo de 24 horas hábiles. A efectos del servicio, el horario hábil es de 08:00 a 20:00. Los domingos y los días festivos no computan como horas hábiles.",
  },
  {
    title: "4. Cuota y activación",
    body: "El servicio funciona mediante una cuota mensual de 12,99 €, con cargo recurrente mediante tarjeta bancaria a través de una plataforma de pago online segura. El alta se completa en dos pasos: (1) el registro de los datos del futuro cliente y (2) el pago de la suscripción. El registro de datos, por sí solo, no constituye la contratación del servicio ni implica ningún cargo. El servicio quedará activo una vez confirmado el pago. La contratación implica la aceptación de estas condiciones y la autorización del correspondiente cargo mensual mientras el servicio permanezca activo.",
  },
  {
    title: "5. Datos de la empresa",
    body: "Titular: Joan Riera Bauzá — NIF 43483435A. Domicilio: 07006, Palma de Mallorca. Contacto: joanriera49@gmail.com.",
  },
  {
    title: "6. Modificaciones de las condiciones",
    body: "La versión vigente de este documento es la 1.0. Si las condiciones cambian, los nuevos registros aceptarán la versión vigente en ese momento; la aceptación ya registrada conservará la versión aceptada en su fecha.",
  },
];

export { PRIVACY_DOC } from "./legal";

export const INDUSTRY_SUGGESTIONS = [
  "Comercio minorista",
  "Restaurante",
  "Bar / cafetería",
  "Peluquería",
  "Centro de estética",
  "Oficina",
  "Tienda",
  "Taller",
  "Farmacia",
];
